(function () {
  function safeItems() {
    let raw;
    try { raw = JSON.parse(localStorage.getItem('selectedRentalItems') || '[]'); }
    catch { raw = []; }
    return Array.isArray(raw) ? raw : [];
  }
  function rentalQty(items) { return items.reduce((s,i)=> s + (i?.quantity || 1), 0); }
  function label(txt, qtyAttr, qty) {
    const cartIcon = '<svg width="15" height="14" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 0a1 1 0 0 0 0 2h.34c.27 0 .66.24.77.83l2.9 15.37a1 1 0 0 0 1.23.78h12.48c.21 0 .4.01.59.02.1 0 .19.02.28.02.29.01.46 0 .57-.02l.08-.03 1.47-8.63c.28-1.23-.69-2.43-1.98-2.43H4.75L4.08 2.46C3.86 1.23 2.76 0 1.34 0H1Zm4.13 8h15.86l-1.56 8.96-.03.1-.02.01H6.82L5.13 8Zm3.63 14.43A1.57 1.57 0 1 0 9.37 24a1.57 1.57 0 0 0-.61-3.04Zm8.64 3.57a1.57 1.57 0 1 0 0-3.13 1.57 1.57 0 0 0 0 3.13Z"/></svg>';
    const inner = qtyAttr ? '<span '+qtyAttr+'>'+qty+'</span>' : qty;
    return '<span style="display:inline-flex;align-items:center;">'+cartIcon+'<span style="margin-left:5px;">'+txt+' ('+inner+')</span></span>';
  }

  function paint() {
    const links = document.querySelectorAll('.utility-bar__menu-link');
    if (!links.length) return;
    const shopCount = Number(window.__SHOP_COUNT__ || 0); // optional server-side inject
    const rq = rentalQty(safeItems());
    links.forEach(link => {
      const t = (link.textContent || '').trim();
      if (t === 'Shopping Cart') link.innerHTML = label('Shopping&nbsp;Cart','',shopCount);
      if (t === 'Rental Cart') {
        link.innerHTML = label('Rental&nbsp;Cart','data-rental-cart-count',rq);
        link.addEventListener('click', e => {
          if (window.GPERental?.openDrawer) { e.preventDefault(); window.GPERental.openDrawer(); }
        }, { once:true });
      }
    });
  }

  document.readyState === 'loading' ? 
    document.addEventListener('DOMContentLoaded', paint) : paint();

  // keep header count in sync cross-tab
  window.addEventListener('storage', ev => {
    if (ev.key !== 'selectedRentalItems') return;
    let items; try { items = JSON.parse(ev.newValue || '[]'); } catch { items = []; }
    const q = Array.isArray(items) ? rentalQty(items) : 0;
    document.querySelectorAll('[data-rental-cart-count]').forEach(n => n.textContent = String(q));
  });

  // one-time cleanup for bad historical values
  if (localStorage.getItem('selectedRentalItems') === 'null' || localStorage.getItem('selectedRentalItems') === 'undefined') {
    localStorage.removeItem('selectedRentalItems');
  }
})();
